import React, { useState, useEffect } from 'react';
import close from '../Asset/close.svg';
import { Modal } from 'react-bootstrap';
import {getUserInfo} from './functions/userInfo';
import {environment} from './functions/environment';

function Alert(props) {
  let userObj;
  if (props.obj.type === "custom") {
    userObj = getUserInfo();
  }
  let [pobj, setPobj] = useState({
    msg: props.obj.msg,
    status: true,
    type: props.obj.type,
    catId: props.obj.catId
  });
  let [capacity, setCapacity] = useState(0);
  const [show, setShow] = useState(true);
  useEffect(()=>{
    
  },[])
  const handleClose = () => {
    setShow(false);
    if (pobj.type == "custom") {
      setPobj({ ...pobj, status: false, type: "displayed" });
      setShow(true);
    }
    else {
      setPobj({ ...pobj, status: true });
    }
  };
  useEffect(() => {
    setShow(props.obj.status);
    setPobj({ ...pobj, type: props.obj.type })
    if (props.obj.type === "custom") {
      getFuelTankCapacity(props.obj.catId);
    }
  }, [props.obj])

  function getFuelTankCapacity(id) {
    fetch(environment.baseUrl + "getFuelTankByPSC", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        productSubCategoryID: id
      })
    }).then((result) => {
      result.json().then((res) => {
        if (res.code == 200) {
          setCapacity(res.data.result[0].fuelCapacity);
        }
        else {
          setCapacity(0)
        }
      })
    })
  }
  return (
    <>
      <Modal show={show} onHide={handleClose} centered backdrop="static" size="sm">
        <Modal.Header>
          <Modal.Title>Message</Modal.Title>
          <button onClick={handleClose} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className='text-center logout-box'>

          {
            pobj.status ?
              <p><b>{props.obj.msg}</b></p>
              :
              <>
                <p><b>Please complete the below actions:</b></p>
                <ul className='text-start'>
                  <li>Set Threshold Values</li>
                  <li>Set Preventive Maintenance</li>
                  {
                    capacity === 0 ?
                      <li> Set Fuel Tank Capacity</li>
                      : ""
                  }
                </ul>
              </>
          }
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Alert
